import { isUndefined } from 'lodash-es';
export class CareOrderBabyFormForParamVerifyDConverter {
    #careOrderBabyForm;
    constructor(careOrderBabyForm) {
        this.#careOrderBabyForm = careOrderBabyForm;
    }
    get data() {
        const { gender, height, weight, age, hospitalBed, symptom, tube, requiredGender, lang, servedItem, notes, contactName, contactGender, contactPhone, contactEmail, hospitalObj, } = this.#careOrderBabyForm;
        const paramVerifyParams = {};
        if (!isUndefined(gender)) {
            paramVerifyParams.patient = {
                ...paramVerifyParams.patient,
                gender,
            };
        }
        if (!isUndefined(height)) {
            paramVerifyParams.patient = {
                ...paramVerifyParams.patient,
                height,
            };
        }
        if (!isUndefined(weight)) {
            paramVerifyParams.patient = {
                ...paramVerifyParams.patient,
                weight,
            };
        }
        if (!isUndefined(age)) {
            paramVerifyParams.patient = {
                ...paramVerifyParams.patient,
                age,
            };
        }
        if (!isUndefined(hospitalBed)) {
            paramVerifyParams.hospitalBed = hospitalBed;
        }
        if (!isUndefined(symptom)) {
            paramVerifyParams.symptom = symptom;
        }
        if (!isUndefined(tube)) {
            paramVerifyParams.tube = tube;
        }
        if (!isUndefined(requiredGender)) {
            paramVerifyParams.requiredGender = requiredGender;
        }
        if (!isUndefined(lang)) {
            paramVerifyParams.lang = lang;
        }
        if (!isUndefined(servedItem)) {
            paramVerifyParams.servedItem = servedItem;
        }
        if (!isUndefined(notes)) {
            paramVerifyParams.notes = notes;
        }
        if (!isUndefined(contactName)) {
            paramVerifyParams.contact = {
                ...paramVerifyParams.contact,
                name: contactName,
            };
        }
        if (!isUndefined(contactGender)) {
            paramVerifyParams.contact = {
                ...paramVerifyParams.contact,
                gender: contactGender,
            };
        }
        if (!isUndefined(contactPhone)) {
            paramVerifyParams.contact = {
                ...paramVerifyParams.contact,
                phone: contactPhone,
            };
        }
        if (!isUndefined(contactEmail) && contactEmail) {
            paramVerifyParams.contact = {
                ...paramVerifyParams.contact,
                email: contactEmail,
            };
        }
        if (!isUndefined(hospitalObj)) {
            paramVerifyParams.hospital = hospitalObj;
        }
        return paramVerifyParams;
    }
}
